import {useEffect, useState} from 'react';
import API from '../API';
import Confirm from './Confirm'
import {useTest} from './hooks/TestHook';
import SliderTest from './SliderTest';
import TestBlockLogic from './TestBlockLogic';
import styleHeader from './testHeader.module.css';
import Timer from "./Timer";

export default function Test({setIsStart, isTestStart}) {

    const api = new API()
    const [test, setTest] = useState({})
    const [confirmIsOpen, setConfirmIsOpen] = useState(false);
    const [isPassed, setPassed] = useState(false)
    const [time, setTime] = useState(null)
    const [slideNumber,setSlideNumber]=useState(1)
    const [rightObj,setRightObj]=useState([])
    useEffect(() => {
        let id = window.location.pathname.split('/').pop()
        if (!id) {
            return
        }
        api.getTest(id).then(data => {
            if (!data) {
                return
            }
            setTest(data)
            setTime(Number.parseInt(data.time)) // приходит количество секунд сколько осталось на тест
            return data.tasks;
        }).then(() => {
            setIsStart(true)
        })
    }, [])

    const {changeAllAnswers, sendTest, changeResult, allAnswers} = useTest()
    const onChangeSlideNumber=(number)=>{
        setSlideNumber(number)
    }
    const onChangeRightObject=(value={})=>{
        setRightObj(item=>[...item,value])
    }
    function sendTestHandler() {
        setPassed(isPassed => {
            return {
                isPassed: true,
            }
        })
        setIsStart(false)

        if(!test.is_demo) {
            sendTest(test.id)
        }
    }

    const testView = test?.tasks && test?.tasks.map(task => <TestBlockLogic changeResult={changeResult}
                                                                            changeAllAnswers={changeAllAnswers}
                                                                            block={task}
                                                                            key={task.id}
                                                                            isPassed={isPassed}
                                                                            setSlideNumber={onChangeSlideNumber}
                                                                            slideNumber={slideNumber}
                                                                            setRightObject={onChangeRightObject}
    />)
    const testHeader = <div className={styleHeader.testHeader}>
        <Timer isPassed={isPassed} startTime={time} sendTestHandler={sendTestHandler}/>
        <h1 className='test-name'>{isTestStart ? test.name : test.name + ': Завершен'}</h1>
        <button className={styleHeader.testSendResultButton} onClick={(e) => {
            setConfirmIsOpen(true);
        }} disabled={isPassed}>Завершить
        </button>
    </div>
    return (
        <>
            <div style={isTestStart ? {} : {paddingTop: '65px'}} className="test-bg">
                <div className="test-container">
                    {testHeader}
                    <SliderTest key="main-slider"
                                data={testView}
                                allAnswers={allAnswers}
                                test={test}
                                setSlideNumber={onChangeSlideNumber}
                                slideNumber={slideNumber}
                                isPassed={isPassed}
                                rightObj={rightObj}
                    />
                </div>
            </div>

            <Confirm setIsOpen={setConfirmIsOpen} SendTest={sendTestHandler} isOpen={confirmIsOpen}/>
        </>
    )

}
